import {useMemo} from 'react';
import {ComboFrequencyEnum} from '../schema-types/globalTypes';

const SINGLE_COMBOS = [
  ComboFrequencyEnum.SINGLE,
  ComboFrequencyEnum.ANNUAL_AND_SINGLE,
  ComboFrequencyEnum.MONTHLY_AND_SINGLE,
  ComboFrequencyEnum.QUARTERLY_AND_SINGLE,
];

function resolve(comboFrequency: ComboFrequencyEnum | undefined) {
  const effective = comboFrequency ?? ComboFrequencyEnum.SINGLE;
  return {
    hasSingle: SINGLE_COMBOS.includes(effective),
    hasRecurring: effective !== ComboFrequencyEnum.SINGLE,
  };
}

export default function useComboFrequency(
  comboFrequency: ComboFrequencyEnum | undefined
) {
  return useMemo(() => resolve(comboFrequency), [comboFrequency]);
}

export function getComboFrequency(comboFrequency: ComboFrequencyEnum | undefined) {
  return resolve(comboFrequency);
}
